export default {
  selfieApproved: true,
  selfieKey: '',
};
